export const URLExisted = typeof URL !== 'undefined';
